import { useState } from "react";
import { VoteUsers } from "../../../components/Vote";
import { WhoClient } from "../../../../types";

export function WhoTable({ who }: { who: WhoClient }) {
    const [option, setOption] = useState("yes");
    const { users, votes } = who;

    const yes = Object.entries(votes).filter(([, v]) => v.vote === "yes").map(([user, vote]) => ({ ...vote, user: users[user] }));
    const maybe = Object.entries(votes).filter(([, v]) => v.vote === "maybe").map(([user, vote]) => ({ ...vote, user: users[user] }));
    const no = Object.entries(votes).filter(([, v]) => v.vote === "no").map(([user, vote]) => ({ ...vote, user: users[user] }));

    return <>
        <div className="who-votes">
            <div className={`who-vote vote-yes active ${option === "yes" ? "selected" : ""}`} onClick={() => setOption("yes")}>{yes.length}x</div>
            {who.isMaybeOption && <div className={`who-vote vote-maybe active ${option === "maybe" ? "selected" : ""}`} onClick={() => setOption("maybe")}>{maybe.length}x</div>}
            <div className={`who-vote vote-no active ${option === "no" ? "selected" : ""}`} onClick={() => setOption("no")}>{no.length}x</div>
        </div>
        <VoteUsers active={option} users={users} votes={votes} isMaybeOption={who.isMaybeOption} onChange={setOption} />
    </>;
}
